import styled, { css } from 'styled-components'
import { colors, device, fonts } from '../../../styles/GlobalVariables'

interface StyledSearchSymbol {
  isSearch?: boolean
  programList?: boolean
  whiteBorderLine?: boolean
  paddingBottom?: number
  iosPaddingBottom?: number
  iosPaddingTop?: number
  borderBottom?: number
}

export const NavigationWrapper = styled.div<{ isNative: 'true' | 'false' }>`
  background: #09090f;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  position: sticky;
  z-index: 99;
  width: 100%;
  top: 0;

  @media only screen and (max-width: 768px) {
    height: 80px;
      padding-top: 10px;
    ${({ isNative }) =>
      isNative === 'true'
        ? css`
            gap: 25%;
            justify-content: flex-end;
          `
        : ''}
`

export const NavigationLogo_13 = styled.div`
  width: 45px;
  height: 45px;
  margin-right: 5.73vw;
  cursor: pointer;
  display: flex;
  align-items: center;

  // ${device.small} {
  //   width: 25px;
  //   height: 25px;
  // }
`
export const NavigationLogo_13_desktop = styled.img`
  width: 100%;
  display: none;

  ${device.small} {
    display: inline-flex;
  }
`
export const NavigationLogo_13_mobile = styled.img`
  width: 100%;
  display: inline-flex;

  ${device.small} {
    display: none;
  }
`
export const SearchLogo = styled.div``

export const SearchImage = styled.img`
  position: relative;
  top: 3px;
`

export const NavItemsMain = styled.div`
  display: flex;
  gap: 2.71vw;
  font-family: 'Narkiss Block RESHET', sans-serif;
  font-size: 22px;
  color: #fff;

  @media only screen and (max-width: 1280px) {
    display: none;
  }
`
export const NavItemsMainMedia = styled.div`
  display: none;

  @media only screen and (max-width: 1280px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Narkiss Block RESHET', sans-serif;
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: rgba(255, 255, 255, 0.8);
    margin-top: 100px;
    gap: 20px;
  }
`

export const ArrowDownSymbol = styled.div`
  display: none;
  @media only screen and (max-width: 1280px) {
    display: block;
    font-weight: bold;
    font-size: 15px;
    margin-right: 5px;
    padding-bottom: 2.5px;
    &:after {
      content: '⌵';
    }
  }
`
export const NavItemsMedia = styled.div<{ isNative: 'true' | 'false' }>`
  display: none;
  @media only screen and (max-width: 1280px) {
    display: inline-flex;
    align-items: center; /* Align vertically */
    justify-content: center; /* Align horizontally */
    width: 112px;
    height: 39px;
    color: ${colors.white};
    border: 1px solid ${colors.white};
    border-radius: 68px;
    font-family: ${fonts.narkis};
    font-size: 20px;
    font-weight: 500;
    padding: 0 2px;
    opacity: 0.7;
    transition: all 0.1s ease-in;
  }
`
export const NavItemsProgram = styled.div<{ isSub?: boolean }>`
  ${props =>
    !props.isSub
      ? css`
          display: flex;
          gap: 2.7vw;
        `
      : css`
          .swiper-slide {
            width: fit-content;
          }
        `};

  font-family: ${fonts.default};
  font-size: 28px;
  color: white;
  font-weight: 600;

  @media only screen and (max-width: 768px) {
    gap: 5.5vw;
    margin-bottom: 5px;
    margin-top: 9.8vw;
    font-size: 25px;
    font-weight: 400;
  }

  @media only screen and (max-width: 1280px) {
    font-size: 25px;
  }
`

export const NavItemsLeft = styled.div`
  display: flex;
  align-items: center;
  margin-left: 5vw;
  gap: 1.7vw;

  > div:not(.ReshetNavItemDiv) {
    opacity: 1;

    &:hover {
      opacity: 0.6;
    }
  }
`
export const LeftMenuSeparator = styled.div`
  width: 2px;
  height: 20px;
  border-radius: 4px;
  background: linear-gradient(91deg, #54fbfe 0%, #1cc7ca 100%);

  @media only screen and (max-width: 1280px) {
    display: none;
  }
`

export const NavItemWrapper = styled.div<StyledSearchSymbol>`
  display: flex;
  cursor: pointer;
  align-items: center;
  color: #fff;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    color: ${({ theme }) => (!theme.active ? '#aaa' : '')};
    cursor: ${({ theme }) => (theme.active ? 'default' : '')};
  }

  @media only screen and (max-width: 1280px) {
    color: ${({ theme }) =>
      theme.active ? '#FFF' : 'rgba(255, 255, 255, 0.50)'};
    ${props =>
      props.iosPaddingBottom
        ? css`
            padding-bottom: ${props.iosPaddingBottom}vw;
          `
        : ''};
    margin-bottom: ${({ theme }) => (theme.borderBottom ? '35' : '0')}px;
    ${({ theme }) =>
      theme.active
        ? css`
            &:after {
              content: '';
              height: 3px;
              width: 100%;
              position: absolute;
              ${({ theme }) =>
                theme.borderBottom &&
                css`
                  background: linear-gradient(91deg, #54fbfe 0%, #1cc7ca 100%);
                `}
              z-index: 1;
              bottom: -12px;
              left: 0;
              border-radius: 3px;
            }
          `
        : ''};
  }
  position: relative;
  overflow: visible;

  ${device.small} {
    ${({ theme }) =>
      theme.active &&
      css`
        &:after {
          content: '';
          height: 3px;
          width: 100%;
          position: absolute;
          background: ${({ theme }) =>
            theme.whiteBorderLine
              ? '#FFF'
              : 'linear-gradient(91deg, #54fbfe 0%, #1cc7ca 100%)'};
          z-index: 1;
          bottom: 0;
          left: 0;
          border-radius: 3px;
        }
      `}

    ${({ theme }) =>
      theme.programList &&
      css`
        @media only screen and (min-width: 1280px) {
          padding-bottom: 10px;
        }
        &:after {
          bottom: 0;
        }
      `}
  }

  @media only screen and (max-width: 1280px) {
    ${/* Override the background property to make it disappear */ ''}
    ${({ theme }) =>
      theme.active &&
      css`
        &:after {
          background: none; /* Disappear the background */
        }
      `}
  }

  ${({ theme }) =>
    theme.programList
      ? css`
          font-weight: 400;
        `
      : ''}
  a {
    text-decoration: none;
    color: inherit;
  }
`
export const ProfileNavItemDiv = styled(NavItemWrapper)`
  margin-top: 1.438rem;
  display: inline-flex;
  align-items: center;
  position: relative;
  border-bottom: transparent;

  ::before,
  ::after {
    content: '';
    border-left: 1px solid #54fbfe;
    height: 1rem; /* Adjust as needed */
    margin: 0 0.5rem;
  }

  ::before {
    margin-left: 1.875rem;
  }

  ::after {
    margin-right: 1.875rem;
  }

  &:hover {
    border-bottom: none;
  }

  @media only screen and (max-width: 1280px) {
    display: none;
  }
`

export const ReshetNavItemDiv = styled(NavItemWrapper)`
  color: ${colors.gray};
  border: 1px solid ${colors.gray};
  border-radius: 25px;
  font-family: ${fonts.narkis};
  background: transparent;
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  opacity: 0.7;
  transition: all 0.1s ease-in;
  font-size: 18px;

  &:hover {
    opacity: 1 !important;
    background: ${colors.white} !important;
    color: ${colors.black};
    border-bottom-color: ${colors.white};
  }

  @media only screen and (max-width: 1280px) {
    display: none;
  }
`
export const ReshetNavItemDivMedia = styled(NavItemWrapper)`
  display: none;

  @media only screen and (max-width: 1280px) {
    color: ${colors.white};
    border: 1px solid ${colors.white};
    border-radius: 25px;
    font-family: ${fonts.narkis};
    display: inline-flex;
    font-weight: bold;
    align-items: center;
    transition: all 0.1s ease-in;
    padding: 14px 20px;
    margin-top: 20px;
  }
`
export const PopupBackground = styled.div`
  display: none;

  @media only screen and (max-width: 1280px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    position: fixed;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 4;
  }
`
export const ClosePopupButton = styled.div`
  display: none;

  @media only screen and (max-width: 1280px) {
    display: block;
    width: 60px;
    height: 60px;

    img {
      width: 100%;
      height: auto;
    }
  }
`
export const NavigationListWrapper = styled.div`
  display: flex;
  gap: 53px;

  @media only screen and (max-width: 1280px) {
    display: block;
  }
`
